import { createContext } from "react"

const QuestionaryContext = createContext();

export default QuestionaryContext;